
import { ApiUpsertAppFormResponseDto } from "@/api/generated/Api";
import BaseCard from "@/components/shared/BaseCard.vue";
import BaseInfoCol from "@/components/shared/BaseInfoCol.vue";
import BaseRow from "@/components/shared/BaseRow.vue";
import { useAutoDeepCloneProp } from "@/fragments/useAutoDeepCloneProp";
import { deepCloneObject } from "@/shared/helpers/deepCloneHelpers";
import { isMobile } from "@/shared/helpers/displayHelpers";
import { validateBoolean, validateNotEmpty } from "@/shared/helpers/validationHelpers";
import { signupDescriptions } from "@/shared/utils/signupDescriptions";
import { defineComponent, PropType, ref, Ref } from "@vue/composition-api";

export default defineComponent({
  name: "ApplyCourseCompetency",
  components: { BaseCard, BaseInfoCol, BaseRow },
  props: {
    value: {
      type: Object as PropType<ApiUpsertAppFormResponseDto>,
      required: true,
    },
  },
  emits: ["input"],
  setup(props, { emit }) {
    const isParagraphOneSummary = ref(true);
    const isParagraphTwoSummary = ref(true);
    const isParagraphThreeSummary = ref(true);

    const applicationModel: Ref<ApiUpsertAppFormResponseDto> = useAutoDeepCloneProp<ApiUpsertAppFormResponseDto>(
      props,
      "value"
    );

    const emitChanges = () => {
      emit("input", deepCloneObject(applicationModel.value));
    };

    return {
      isMobile,
      applicationModel,
      isParagraphOneSummary,
      isParagraphTwoSummary,
      isParagraphThreeSummary,
      validateNotEmpty,
      emitChanges,
      validateBoolean,
      signupDescriptions,
    };
  },
});
